import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '../../Utility/Grid/Grid';
import Button from '../../BuildingBlocks/Button/Button';
import Modal from '../Modal';
import { StyledInternalGrid, StyledIcon } from './ConfirmationModal.styles';
import Text from '../../BuildingBlocks/Text/Text';

export default class ConfirmationModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    targetValue: PropTypes.string.isRequired
  };

  static defaultProps = {
    open: false
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      loading: false
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  handleOpen = event => {
    if (event) event.stopPropagation();
    this.setState({ open: true });
  };

  handleClose = event => {
    if (event) event.stopPropagation();
    this.setState({ open: false });
  };

  handleAction = event => {
    if (event) event.stopPropagation();
    const { handleConfirmation, targetValue } = this.props;
    this.setState({ loading: true });
    handleConfirmation(targetValue);
  };

  render() {
    const { open, loading } = this.state;
    const { title, icon } = this.props;
    return (
      <>
        <StyledIcon onClick={this.handleOpen} selectedIcon={icon} />
        <Modal handleClose={this.handleClose} showClose={false} open={open} width="600px" height="300px">
          <StyledInternalGrid>
            <Grid.Row>
              <Text align="center">{title}</Text>
            </Grid.Row>
            <Grid.Row style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Grid.Col xs={4}>
                <Button loading={loading} onClick={this.handleAction} size="sm" theme="blue" uppercase>
                  confirm
                </Button>
              </Grid.Col>
              <Grid.Col xs={4}>
                <Button onClick={this.handleClose} size="sm" theme="ghost" uppercase>
                  Cancel
                </Button>
              </Grid.Col>
            </Grid.Row>
          </StyledInternalGrid>
        </Modal>
      </>
    );
  }
}
